import { AIChatMessageHistory } from '../../types/open-ai-api-types';

// Chat history ************************************************************************************
// pathname: /chat/history/{userId}/{chatAgentId}
// ************************************************************************************************
export type ChatHistoryResponse = AIChatMessageHistory[];
export const isChatHistoryResponseOk = (res: ChatHistoryResponse | void): res is ChatHistoryResponse => res !== undefined && res !== null && res.length >= 0;
